// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__4ueR_","modalContainer":"styles_modalContainer__AYkZq","modalPaper":"styles_modalPaper__w4k1g","link":"styles_link__ZNtdR"};